export enum RESPONSE_RUT{
    FORMATO_RUT_INCORRECTO = 1,
    RUT_INVALIDO = 2,
    CANTIDAD_REINTENTOS_SUPERADA = 3,
    RUT_OCUPADO = 4,
    RUT_DISPONIBLE = 5
}